/* TAFOYA luxury layer: reveal on scroll, scent tabs, in-view video playback */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('[data-tf-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function videos(root) {
    var vids = root.querySelectorAll('video[data-tf-autoplay], [data-tf-autoplay-wrap] video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play && v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && !reduce) {
          if (v.preload === 'none') v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  }

  function tabs(root) {
    root.querySelectorAll('[data-tf-tabs]').forEach(function (wrap) {
      if (wrap.dataset.tfReady) return;
      wrap.dataset.tfReady = '1';
      var btns = wrap.querySelectorAll('[role="tab"]');
      function select(btn, focus) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) { panel.hidden = !on; panel.classList.toggle('is-active', on); }
        });
        if (focus) btn.focus();
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (document.dir === 'rtl') dir = -dir;
          if (dir) { e.preventDefault(); select(btns[(i + dir + btns.length) % btns.length], true); }
        });
      });
    });
  }

  /* Homepage "Write a review": go to the chosen fragrance and open its review form */
  function reviewPick(root) { root.querySelectorAll('[data-tf-review-pick]').forEach(function (form) { form.addEventListener('submit', function (e) { e.preventDefault(); var url = form.querySelector('select').value; if (url) window.location.href = url + '#write-review'; }); }); }
  function openReviewForm() { if (window.location.hash !== '#write-review') return; var tries = 0; var timer = setInterval(function () { var modal = document.querySelector('.jdgm-write-review-modal__content'); var btn = document.querySelector('.jdgm-review-widget .jm-action-buttons__button'); if ((modal && modal.getClientRects().length) || ++tries > 30) { clearInterval(timer); return; } if (btn) { btn.scrollIntoView({ block: 'center' }); btn.click(); } }, 500); }

  /* Product page: turn Judge.me's review grid into a carousel with arrows */
  function reviewCarousel() {
    if (!document.getElementById('reviews')) return;
    var tries = 0;
    var timer = setInterval(function () {
      var track = document.querySelector('.jdgm-review-widget .jdgm-masonry-grid__container');
      if (++tries > 40) clearInterval(timer);
      if (!track || track.dataset.tfCarousel) return;
      track.dataset.tfCarousel = '1';
      var nav = document.createElement('div');
      nav.className = 'tf-rcar-nav';
      nav.innerHTML = '<button type="button" aria-label="Previous reviews">←</button><button type="button" aria-label="Next reviews">→</button>';
      nav.addEventListener('click', function (e) {
        var btn = e.target.closest('button');
        if (btn) track.scrollBy({ left: (btn === nav.firstChild ? -1 : 1) * track.clientWidth, behavior: 'smooth' });
      });
      var toggle = function () { nav.hidden = track.scrollWidth <= track.clientWidth + 1; };
      track.after(nav);
      toggle();
      window.addEventListener('resize', toggle);
    }, 500);
  }

  function init(root) { reveal(root); videos(root); tabs(root); reviewPick(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); openReviewForm(); reviewCarousel(); });
  } else { init(document); openReviewForm(); reviewCarousel(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
